// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"8":"mobile","761":"PC"}[chunkId] + "." + {"8":"76cd1929","761":"1cac98fb"}[chunkId] + ".css";
};